import { Navigate } from 'react-router';
import { Dialog, DialogContent, Typography } from '@mui/material';

import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { useAuth } from '../../../../../../hooks/index.js';
import { getActionedByName } from '../../../utils';
import { MedicareIHIDetails } from '../../../components';
import { usePatientIntakeStatusContext } from '../../../hooks';

type ViewMedicareIHIDetailsModalProps = {
  step: IntakeStatusBaseSteps['MEDICARE_VERIFICATION'];
  onClose: () => void;
};

const ViewMedicareIHIDetailsModal = ({ step, onClose }: ViewMedicareIHIDetailsModalProps) => {
  const { patientId, isHealthcareProvider } = usePatientIntakeStatusContext();
  const { user } = useAuth();

  const verifiedByName = getActionedByName({ currentUserId: user?.uid, step });

  const { status, actionedAt } = step.currentStatus;

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <MedicareIHIDetails
          patientId={patientId}
          verifiedByName={isHealthcareProvider ? verifiedByName : null}
          verifiedAt={actionedAt}
          verificationStatus={status}
        />
      </DialogContent>
    </Dialog>
  );
};

type MedicareIHIModalProps = {
  step: IntakeStatusBaseSteps['MEDICARE_VERIFICATION'];
  isOpen: boolean;
  onClose: () => void;
};

export const MedicareIHIModal = ({ step, isOpen, onClose }: MedicareIHIModalProps) => {
  const { userType } = useAuth();

  const { status } = step.currentStatus;

  if (status === 'COMPLETED') {
    return <ViewMedicareIHIDetailsModal step={step} onClose={onClose} />;
  }

  if (userType === 'patient') {
    return <Navigate to="/medical-info/concession-cards" />;
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent>
        <Typography variant="body2">
          The patient will update their Medicare details or IHI number in their account details page.
        </Typography>
        <Typography variant="body2">Alternatively, you can also update their details on their page.</Typography>
      </DialogContent>
    </Dialog>
  );
};
